export enum WarningSnackbarDataCy {
    SNACK_BAR = 'warning-snack-bar'
}
